import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newRequestFunction from "../Utils/newSGF";

import {
  TREG_FETCH_ALL_STATES,
  REGISTER_TRAINING_CENTRE,
  FETCH_ALL_ACTIVE_SKILLS_TREG,
} from "../ActionTypes";

import {
  tregFetchAllStatesSuccess,
  registerTrainingCentreSuccess,
  registerTrainingCentreFailure,
  fetchAllActiveSkillsTregSuccess,
} from "../Actions";

import {
  getStates,
  registerTrainingCenter,
  getAllActiveSkills,
} from "../Api";


// Requests
const tregGetAllStatesRequest = function* ({ payload }) {
  yield call(requestFunction, tregFetchAllStatesSuccess, getStates, payload)
}

const registerTrainingCenterRequest = function* ({ payload }) {
  yield call(newRequestFunction, registerTrainingCentreSuccess, registerTrainingCentreFailure, registerTrainingCenter, payload)
}
 
const getAllActiveSkillsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllActiveSkillsTregSuccess, getAllActiveSkills, payload)
}



// Watchers
const tregGetAllStatesWatcher = function* () {
  yield takeEvery(TREG_FETCH_ALL_STATES, tregGetAllStatesRequest)
}

const registerTrainingCenterWatcher = function* () {
  yield takeEvery(REGISTER_TRAINING_CENTRE, registerTrainingCenterRequest)
}

const getAllActiveSkillsWatcher = function* () {
  yield takeEvery(FETCH_ALL_ACTIVE_SKILLS_TREG, getAllActiveSkillsRequest)
}



export default function* rootSaga() {
  yield all([
    fork(tregGetAllStatesWatcher),
    fork(registerTrainingCenterWatcher),
    fork(getAllActiveSkillsWatcher),
  ])
}